import React from 'react';
import spinner from "../../assets/images/loadingGif.gif";

export const LoadingSpinner = ({ size = "32px" }) => (
  <div style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
    <img src={spinner} width={size} alt="Loading..." />
  </div>
); 